import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-closet-doors-plinth-info',
  templateUrl: './closet-doors-plinth-info.component.html',
})
export class ClosetDoorsPlinthInfoComponent {
  constructor(public modalService: ModalService) {}
}
